export type Repository = {
	owner: string
	name: string
}

export const DEFAULT_REPOS: Repository[] = [
	{ owner: 'sidekickdelivery', name: 'wineapp' },
	{ owner: 'sidekickdelivery', name: 'app.sidekick' },
	{ owner: 'sidekickdelivery', name: 'app.warehouse' },
	{ owner: 'sidekickdelivery', name: 'app.warehouse.api' },
	{ owner: 'sidekickdelivery', name: 'app.warehouse.client' },
	{ owner: 'sidekickdelivery', name: 'app.printserver' },
	{ owner: 'sidekickdelivery', name: 'app.sftp' },
	{ owner: 'sidekickdelivery', name: 'deploy.whapi' },
	{ owner: 'sidekickdelivery', name: 'deploy.dmgr' },
	{ owner: 'sidekickdelivery', name: 'deploy.wineapp' },
	{ owner: 'sidekickdelivery', name: 'deploy.tools' },
	{ owner: 'hcc-co', name: 'tritails-api' },
	{ owner: 'hcc-co', name: 'Shopify-Product-Metadata' },
	{ owner: 'rocket-house', name: 'omniauth-wild-apricot' },
]
